import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import FileUploadField from './FileUploadField';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';

import './index.css';

export default (element, store) => {
  const root = createRoot(element);
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <FileUploadField
          allowedFileTypes={element.dataset.allowedFileTypes ? JSON.parse(element.dataset.allowedFileTypes) : null}
          hideDescription={element.dataset.hideDescription}
          hideType={element.dataset.hideType}
          inputName={element.dataset.inputName}
          maxNumberOfFiles={element.dataset.maxNumberOfFiles}
        />
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
